import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { AccessService } from '@app-core/services/access/access.service';
import { PORTAL_RELEASE_VERSION } from '@app-core/constants/constants';

@Injectable({
  providedIn: 'root',
})
export class MixPanelService {
  constructor(private accessService: AccessService) {}

  private getCommonProperties(eventName: string): Record<string, any> {
    const loginInfo = this.accessService.getLoginInfo();

    return {
      'App Name': 'fleet portal',
      'App Version': PORTAL_RELEASE_VERSION,
      'Portal Domain': window.location.hostname,
      'User Name': loginInfo?.name || '',
      'User Type': loginInfo?.userType || '',
      'Fleet Id': this.accessService.currentFleet,
      'Fleet Name': loginInfo?.fleets?.find((f: any) => f.fleetId === this.accessService.currentFleet)?.fleetName || '',
      'User Metadata': loginInfo?.userMetadata ? JSON.stringify(loginInfo.userMetadata) : '',
      'Current DateTime': new Date().toISOString(),
      'Current User Country': this.accessService.getUserCountry() || '',
      'Current Timezone': this.accessService.currentTimeZone || '',
      Timezone: this.accessService.currentTimeZone,
      'Metric Unit': this.accessService.currentMetricUnit,
      Language: this.accessService.currentLanguage,
      Theme: this.accessService.currentTheme,
      'Cookies Consent': this.accessService.currentCookiesConsent,
      'Table Page Size': this.accessService.currentTablePageSize,
      Role: this.accessService.getUserPermissions().includes('admin') ? 'Admin' : 'User',
      'Event Name': eventName,
    };
  }

  public track(eventName: string, customProps: Record<string, any> = {}) {
    const properties = {
      ...this.getCommonProperties(eventName),
      ...customProps,
    };

    mixpanel.track(eventName, properties);
  }
}
